import { PayloadAction } from '@reduxjs/toolkit';
import type { IContentsData } from '../../types';
import { createSliceSteamup } from '../common';

interface IContentState {
  loading: boolean;
  list: IContentsData[];
  filter: {
    input: string,
    option: string,
    order: string,
    contentsType: string,
  }
}

const allContentsManageSlice = createSliceSteamup(
  'allContentsManage',
  {
    loading: true,
    list: [],
    filter: {
      input: '',
      option: '',
      order: '',
      contentsType: '',
    },
  } as IContentState,
  {
    setListInit(state, { payload }: PayloadAction<(typeof state.list)>) {
      state.list = payload;
    },
    setKeyword(state, { payload }: PayloadAction<(typeof state.filter.input)>) {
      state.filter.input = payload;
    },
    setOption(state, { payload }: PayloadAction<(typeof state.filter.option)>) {
      state.filter.option = payload;
    },
    setOrder(state, { payload }: PayloadAction<(typeof state.filter.order)>) {
      state.filter.order = payload;
    },
    setContentsType(state, { payload }: PayloadAction<(typeof state.filter.contentsType)>) {
      state.filter.contentsType = payload;
    },
    removeContent(state, { payload }: PayloadAction<{ uuid: string }>) {
      state.filter.input = payload.uuid;
      // const string = state.fliter.input(({ uuid }) => uuid === payload.uuid);
      // if (index > -1) {
      //   state.list.splice(index, 1);
      // }
    },
  },

);

export default allContentsManageSlice;
